import React, { useState } from 'react';

import { useCurrentUser } from '@klp/auth';
import { Client } from '@klp/client/classes';
import { Heading } from '@klp/design';
import { Loader } from '@klp/design/Loader';
import { Main } from '@klp/layout';

import {
    useGetUserClientsQuery,
    useSelectClientMutation,
} from '../Select/rtkApi';
import { ClientSelectionTables } from '../Select/views/ClientSelectionTables';

export const RequireClientChoice: React.FC = ({ children }) => {
    const { currentUser, isAdmin, isAuthenticated } = useCurrentUser();
    const [selectClient] = useSelectClientMutation();
    const [choiceConfirmed, setChoiceConfirmed] = useState(false);

    const { data: clients = [], isLoading } = useGetUserClientsQuery(
        undefined,
        {
            skip: !isAuthenticated || !currentUser || isAdmin,
        },
    );

    const handleSelectClient = (client: Client) => {
        selectClient(Client.parseObject(client));
        setChoiceConfirmed(true);
    };

    // eslint-disable-next-line react/jsx-no-useless-fragment
    if (isAdmin || choiceConfirmed) return <>{children}</>;

    if (isLoading) {
        return (
            <Main>
                <Loader isLoading={true} />
            </Main>
        );
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    if (clients.length <= 1) return <>{children}</>;

    return (
        <Main>
            <div className="ClientSelect">
                <Heading
                    klpHeadingLevel="THREE"
                    translation="clientSelect.chooseClient"
                    marginBottom="compact"
                />
                <ClientSelectionTables
                    clients={clients}
                    onSelectClient={handleSelectClient}
                />
            </div>
        </Main>
    );
};
